import { Injectable } from '@angular/core';
import { SnotifyService } from 'ng-snotify';

@Injectable()
export class CustomNotifyServiceService {

  constructor(private snotifyService: SnotifyService) {
    
  }

  notifyCustomFn(data) {
    const statusCode = data['code'];
    const statusMessage = data['message'];
    let actionType = '';

    if (statusCode === 200) {
      actionType = actionType + ' ' + ' Success';
      this.snotifyService.success(statusMessage, actionType, {
        timeout: 3000,
        showProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        titleMaxLength: 50
      });
    } else if (statusCode === 503)  {
      actionType = actionType + ' ' + ' Warning';
      this.snotifyService.warning(statusCode +": "+statusMessage, actionType, {
        timeout: 4000,
        showProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        titleMaxLength: 50
      });
    } else if (statusCode === 302)  {
      actionType = actionType + ' ' + ' Warning';
      this.snotifyService.warning(statusCode +": "+statusMessage, actionType, {
        timeout: 4000,
        showProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        titleMaxLength: 50
      });
    } else  {
      actionType = actionType + ' ' + ' Error';
      this.snotifyService.error(statusCode +": "+statusMessage, actionType, {
        timeout: 5000,
        showProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        titleMaxLength: 50
      });
    }
  }

  notifyCustomErrorFn(error) {
    let errorContent = error['error'];
    const statusCode = error['status'];
    const errorCode = error['code'];
    const statusMessage = errorContent['message'];

    let actionType = '';
     if (statusCode === 503)  {
      actionType = actionType + ' ' + ' Warning';
      this.snotifyService.warning(statusCode +": "+statusMessage, actionType, {
        timeout: 4000,
        showProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        titleMaxLength: 50
      });
    } 
  }

}
